export default __webpack_public_path__ + "static/media/blackNavbarIcon.6d7b99d7.svg";